export default {
    list: { method: 'post', url: 'v1/movida/application/list' },
    show: { method: 'post', url: 'v1/movida/application/show' },
    edit: { method: 'post', url: 'v1/movida/application/edit' },
    register: { method: 'post', url: 'v1/movida/application/register' },
    listScope: { method: 'post', url: 'v1/movida/scope/list' },
}